import { css } from '@emotion/react';
import { ScheduleKnowledge } from '@weave/schema-gen-ts/dist/schemas/ai-settings/v1/ai_settings.pb';
import { useTranslation } from '@frontend/i18n';
import { AddCustomDetails } from '../../common/add-custom-details';
import { KnowledgeFormSection } from '../../common/knowledge-form-section';
import { CancellationPolicyInput } from './cancellation-policy-input';
import { useScheduleKnowledgeForm } from './use-schedule-knowledge-form';

type Props = {
  locationId: string;
  isManageAll?: boolean;
  presentFields?: Record<keyof ScheduleKnowledge, boolean>;
};

export const ScheduleKnowledgeForm = ({ locationId, isManageAll = false, presentFields }: Props) => {
  const { t } = useTranslation('ai-receptionist-settings');

  const { getFieldProps, isCancellationPolicyDirty, touchedFields, fieldErrors } = useScheduleKnowledgeForm({
    locationId,
    isManageAll,
  });

  return (
    <div css={styles.container}>
      <KnowledgeFormSection
        title={t('Cancellation Policy')}
        description={t('What is your cancellation policy?')}
        isDirty={isCancellationPolicyDirty}
        hasError={!!touchedFields[locationId]?.cancellationPolicy && !!fieldErrors[locationId]?.cancellationPolicy}
        showBulkOverrideWarningAlert={isManageAll && !!presentFields?.cancellationPolicy}
      >
        <CancellationPolicyInput fieldProps={getFieldProps('cancellationPolicy')} />
      </KnowledgeFormSection>
      {!isManageAll && <AddCustomDetails />}
    </div>
  );
};

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    gap: var(--fabric-space-gap-xl);
  `,
};
